export const getEmploymentShorthand = (shortString) => {
    if (shortString === 'Vast') return 'Vast';
    if (shortString === 'Tijdelijk') return 'Tijdelijk';
    if (shortString === 'Tijdelijk met uitzicht op vast')
        return 'Tijdelijk mogelijk vast';
    if (shortString === 'Gast') return 'Gast';
    if (shortString === 'Hybride expert') return 'Hybride expert';
};
